import React, { Component } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';

class ShareTable extends Component {


  render() {
    
    return (
      <div>
        <BootstrapTable keyField="_id"
          data={this.props.data} 
          columns={this.props.columns}
          wrapperClasses="table-responsive"
        />
        <div>
          <p>Message:</p>
          <p>{this.props.message}</p>
        </div>
      </div>
    )
  }
}

export default ShareTable;


// WEBPACK FOOTER //
// ./src/views/PersonalHealthRecord/ShareTable.js